<template>
  <div :class="elementClass" @click="click">
    <slot></slot>
  </div>
</template>

<script>
import { tabBarItemClass } from "../prefix";
export default {
  props: {
    value: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    elementClass() {
      return tabBarItemClass + (this.active ? " active" : "");
    },
  },
  methods: {
    click() {
      return this.$parent.childClick(this);
    },
  },
};
</script>

<style lang="scss">
@import "../scss/import.scss";
$element: $prefix + "-tab-bar-item";

#{$element} {
  min-height: 48px;
  padding: 0 16px;
  line-height: 48px;
  // text-transform: uppercase;
  white-space: nowrap;
  font-weight: 400;
  color: $color-grey-700;
  justify-content: center;
  cursor: pointer;
  @include transition(all 0.2s $animation-deceleration-curve-timing-function);
  &:hover {
    background: rgba($color-grey-500, 0.1);
  }

  &.active {
    color: $theme-primary;
    font-weight: 500;
  }
}
</style>
